import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  // useLocation gives us access to the current route's location object
  const { pathname } = useLocation();

  useEffect(() => {
    // This function runs every time the `pathname` changes (i.e., a new page is loaded)
    window.scrollTo(0, 0); 
  }, [pathname]); // Dependency array: triggers the effect only when the path changes

  // This component doesn't render anything, it only handles a side effect
  return null;
};

export default ScrollToTop;